import { Button, Divider, Grid, Typography } from "@mui/material";
import { forwardRef, useState } from "react";
import { assetService, thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import Modal, { CommonModalProps } from "../../Modals";
import SearchTitleOrAsset from "../../Modals/ModalCreateShare/search-title-or-asset";
import TitleCollectionCard from "../../Cards/TitleCollectionCard/title-collection-card";
import React from "react";
import EmptyListSlot from "../../Misc/EmptyListSlot";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import { useTranslation } from "react-i18next";

export type ModalGroupUserPanelTitleIdAssociationElementProps = {
  titleIds: number[];
  setTitleIds: React.Dispatch<React.SetStateAction<number[]>>;
};

export type ModalGroupUserPanelTitleIdAssociationProps =
  CommonModalProps<ModalGroupUserPanelTitleIdAssociationElementProps>;

const ModalGroupUserPanelTitleIdAssociation = forwardRef<any, ModalGroupUserPanelTitleIdAssociationProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const { closeModal, titleIds, setTitleIds } = props;
    const [titles, setTitles] = useState<DbAssetObjectInfos[]>([]);
    const [canSave, setCanSaved] = useState<boolean>(false);

    const handleCancelClick = () => {
      closeModal();
    };

    const handleConfirm = () => {
      setTitleIds(titles.map((x) => x.id));
      setCanSaved(false);
      closeModal();
    };

    const onClickRemove = (id: number) => {
      setTitles((current) => current.filter((x) => x.id !== id));
      setCanSaved(true);
    };

    const onSelect = (item?: DbAssetObjectInfos, items?: DbAssetObjectInfos[]) => {
      if (item) {
        if (!titles.includes(item)) {
          setCanSaved(true);
          setTitles((prevState) => [item, ...prevState]);
        }
      } else if (items) {
        items?.filter((x) => !titles.map((y) => y.id).includes(x.id));
        setCanSaved(true);
        setTitles((prevState) => [...items, ...prevState]);
      }
    };

    React.useEffect(() => {
      assetService.GetTitleInfosByObjectIds(titleIds).then(function (response) {
        if (response.success)
          setTitles(
            response.results?.sort((a, b) => {
              if (a.name < b.name) return -1;
              else return 1;
            }) || []
          );
      });
    }, [titleIds]);

    return (
      <Modal
        title={t("modal:title.linkTitlesToGroup")}
        reference={ref}
        closeModal={handleCancelClick}
        width={700}
        footer={
          <Button variant="contained" color="primary" onClick={handleConfirm} disabled={!canSave}>
            {t("common:confirm")}
          </Button>
        }
      >
        <SearchTitleOrAsset isAsset={false} onSelect={onSelect} itemSelectedId={titles.map((x) => x.id)} />

        <Divider sx={{ mb: 2, mt: 2 }} />
        <Typography mb={2}>{t("modal:modalGroupUserPanelTitleIdAssociation.body.currentlyFiltered")}</Typography>
        {titles.length > 0 ? (
          titles.map((x) => (
            <Grid container key={x.id}>
              <Grid item xs={12}>
                <TitleCollectionCard
                  sx={{ mb: 2 }}
                  poster={thumbnailService.GetObjectPosterUrl(x.id, ThumbnailSize.small)}
                  title={x.name}
                  onClickAdd={() => false}
                  onClickRemove={() => onClickRemove(x.id)}
                  status="added"
                />
              </Grid>
            </Grid>
          ))
        ) : (
          <EmptyListSlot
            title={t("component:emptyListSlot.title.itIsEmptyHere")}
            desc={t("component:emptyListSlot.desc.addTitlesToFilterGroupAccess")}
            icon={<CollectionsBookmarkOutlinedIcon />}
            sx={{ background: "transparent" }}
            height="100%"
          ></EmptyListSlot>
        )}
      </Modal>
    );
  }
);

export default ModalGroupUserPanelTitleIdAssociation;
